import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getMedicalInfoPage } from "@/_pages/medical-info/api";
import type { MedicalInfoPageType } from "@/_pages/medical-info/model";
import { MedicalInfoPage } from "@/_pages/medical-info/ui";

type PageProps = {
  cms: MedicalInfoPageType;
};

const Page = (props: PageProps) => {
  const { cms } = props;

  return <MedicalInfoPage data={cms} />;
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getMedicalInfoPage()),
      };
    },
    { res },
  );
}

export default Page;
